import React from 'react'

function Password({label, placeholder, value, setValue, view}) {
  return (
    <div className='w-full flex justify-center items-center'>
    <form>
        <div>
        <label className='text-black text-[1.3vmax] font-semibold'>{label}:</label></div>
        <div>
        <input onChange={(e)=>{
          setValue(e.target.value);
        }} className={`rounded-[0.2vmax] ${view=='delete' ? 'border-2 border-black' : ''} text-[1.1vmax] w-[20vmax] h-[2vmax] p-[0.5vmax]`} placeholder={placeholder} type='password'></input></div>
    </form>
</div>
  )
}

export default Password